module.exports = __webpack_public_path__ + "static/HSE_Supplement_2_to_EOM-76660014a1f4cb08db57c4ab8392cc21.pdf";